export const LOG_IN = 'LOG_IN';
export const SET_USER = 'SET_USER';
export const LOG_OUT = 'LOG_OUT';
export const SET_SITE = 'SET_SITE';
